import data from '../assets/tractorZones.json';

export interface TractorZoneProperties extends Record<string, unknown> {
  zone: string;
  tractors: string;
  location: string;
  cycle1: string;
  cycle2?: string;
  cycle3?: string;
  cycle4?: string;
  cycle5?: string;
}

export type TractorZoneFeature = GeoJSON.Feature<GeoJSON.Geometry, TractorZoneProperties>;
export type TractorZoneFeatureCollection = GeoJSON.FeatureCollection<
  GeoJSON.Geometry,
  TractorZoneProperties
>;

export const fetch = async (): Promise<TractorZoneFeatureCollection> => {
  return data as TractorZoneFeatureCollection;
};
